import Script from './utils/scripts';
import View from './utils/view';

View.init(Script.decode);
